import { render, staticRenderFns } from "./CanteenIndex.vue?vue&type=template&id=debd8952&scoped=true&"
import script from "./CanteenIndex.vue?vue&type=script&lang=ts&"
export * from "./CanteenIndex.vue?vue&type=script&lang=ts&"
import style0 from "./CanteenIndex.vue?vue&type=style&index=0&id=debd8952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debd8952",
  null
  
)

export default component.exports